var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _g, _path437, _g2, _path438, _g3, _path439, _g4, _path440, _g5, _path441, _g6, _path442, _g7, _path443, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrWithNeoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 95,
    viewBox: "0 0 97 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 0.536133H0V94.7214H97V0.536133Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 5.62646H34.083V8.17283H36.7055V5.62646Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 5.62646H41.9473V8.17283H44.5697V5.62646Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 5.62646H44.5674V8.17283H47.1899V5.62646Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 5.62646H47.1895V8.17283H49.8119V5.62646Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 5.62646H49.8115V8.17283H52.434V5.62646Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 5.62646H52.4316V8.17283H55.0541V5.62646Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 5.62646H55.0537V8.17283H57.6761V5.62646Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 5.62646H60.2969V8.17283H62.9193V5.62646Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 5.62646H62.9189V8.17283H65.5414V5.62646Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 5.62646H68.1621V8.17283H70.7846V5.62646Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 8.17285H28.8379V10.7192H31.4604V8.17285Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 8.17285H31.4609V10.7192H34.0834V8.17285Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 8.17285H34.082V10.7192H36.7045V8.17285Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 8.17285H36.7031V10.7192H39.3256V8.17285Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 8.17285H41.9473V10.7192H44.5697V8.17285Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 8.17285H44.5674V10.7192H47.1899V8.17285Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 8.17285H52.4316V10.7192H55.0541V8.17285Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 8.17285H55.0537V10.7192H57.6761V8.17285Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 8.17285H57.6768V10.7192H60.2992V8.17285Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 8.17285H60.2969V10.7192H62.9193V8.17285Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 8.17285H68.1621V10.7192H70.7846V8.17285Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 10.7192H26.2178V13.2656H28.8402V10.7192Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 10.7192H28.8379V13.2656H31.4604V10.7192Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 10.7192H31.4609V13.2656H34.0834V10.7192Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 10.7192H39.3242V13.2656H41.9467V10.7192Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 10.7192H41.9473V13.2656H44.5697V10.7192Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 10.7192H44.5674V13.2656H47.1899V10.7192Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.435 10.7192H49.8125V13.2656H52.435V10.7192Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 10.7192H52.4316V13.2656H55.0541V10.7192Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 10.7192H55.0537V13.2656H57.6761V10.7192Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 10.7192H60.2969V13.2656H62.9193V10.7192Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 10.7192H62.9189V13.2656H65.5414V10.7192Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 10.7192H65.542V13.2656H68.1645V10.7192Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 10.7192H68.1621V13.2656H70.7846V10.7192Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 13.2627H26.2178V15.8091H28.8402V13.2627Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 13.2627H39.3242V15.8091H41.9467V13.2627Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 13.2627H44.5674V15.8091H47.1899V13.2627Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 13.2622H49.8115V15.8086H52.434V13.2622Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 13.2627H52.4316V15.8091H55.0541V13.2627Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 13.2627H57.6768V15.8091H60.2992V13.2627Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 13.2627H60.2969V15.8091H62.9193V13.2627Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 13.2622H65.542V15.8086H68.1645V13.2622Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 13.2622H68.1621V15.8086H70.7846V13.2622Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 15.8091H28.8379V18.3555H31.4604V15.8091Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 15.8091H31.4609V18.3555H34.0834V15.8091Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 15.8091H34.083V18.3555H36.7055V15.8091Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 15.8091H36.7031V18.3555H39.3256V15.8091Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 15.8091H39.3242V18.3555H41.9467V15.8091Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 15.8091H44.5674V18.3555H47.1899V15.8091Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 15.8091H47.1895V18.3555H49.8119V15.8091Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 15.8091H49.8115V18.3555H52.434V15.8091Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 15.8091H52.4316V18.3555H55.0541V15.8091Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 15.8091H55.0537V18.3555H57.6761V15.8091Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 15.8091H60.2969V18.3555H62.9193V15.8091Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 15.8091H65.542V18.3555H68.1645V15.8091Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 18.356H28.8379V20.9023H31.4604V18.356Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 18.356H31.4609V20.9023H34.0834V18.356Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 18.356H36.7031V20.9023H39.3256V18.356Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 18.356H39.3242V20.9023H41.9467V18.356Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 18.356H41.9473V20.9023H44.5697V18.356Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 18.356H55.0537V20.9023H57.6761V18.356Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 18.356H62.9189V20.9023H65.5414V18.356Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 18.356H68.1621V20.9023H70.7846V18.356Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 20.8999H26.2178V23.4463H28.8402V20.8999Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 20.8999H31.4609V23.4463H34.0834V20.8999Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 20.8999H36.7031V23.4463H39.3256V20.8999Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 20.8999H41.9473V23.4463H44.5697V20.8999Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 20.8999H47.1895V23.4463H49.8119V20.8999Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 20.8999H52.4316V23.4463H55.0541V20.8999Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 20.8999H57.6768V23.4463H60.2992V20.8999Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 20.8999H62.9189V23.4463H65.5414V20.8999Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 20.8999H68.1621V23.4463H70.7846V20.8999Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 23.4468H28.8379V25.9931H31.4604V23.4468Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 23.4468H31.4609V25.9931H34.0834V23.4468Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 23.4463H36.7031V25.9927H39.3256V23.4463Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 23.4468H44.5674V25.9931H47.1899V23.4468Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 23.4468H47.1895V25.9931H49.8119V23.4468Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 23.4468H62.9189V25.9931H65.5414V23.4468Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 23.4468H65.542V25.9931H68.1645V23.4468Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 25.9922H13.1074V28.5385H15.7299V25.9922Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.352 25.9922H15.7295V28.5385H18.352V25.9922Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 25.9922H20.9727V28.5385H23.5951V25.9922Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 25.9922H23.5947V28.5385H26.2172V25.9922Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 25.9922H28.8379V28.5385H31.4604V25.9922Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 25.9922H34.083V28.5385H36.7055V25.9922Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 25.9922H47.1895V28.5385H49.8119V25.9922Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 25.9922H52.4316V28.5385H55.0541V25.9922Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 25.9922H65.542V28.5385H68.1645V25.9922Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 25.9922H68.1621V28.5385H70.7846V25.9922Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 25.9922H81.2715V28.5385H83.894V25.9922Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 25.9922H83.8916V28.5385H86.514V25.9922Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 28.5356H5.24316V31.082H7.86563V28.5356Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 28.5356H10.4883V31.082H13.1107V28.5356Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 28.5356H13.1074V31.082H15.7299V28.5356Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 28.5356H18.3525V31.082H20.975V28.5356Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 28.5356H26.2178V31.082H28.8402V28.5356Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 28.5356H28.8379V31.082H31.4604V28.5356Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 28.5356H31.4609V31.082H34.0834V28.5356Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 28.5356H34.082V31.082H36.7045V28.5356Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 28.5356H36.7031V31.082H39.3256V28.5356Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 28.5356H44.5674V31.082H47.1899V28.5356Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 28.5356H52.4316V31.082H55.0541V28.5356Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 28.5356H55.0537V31.082H57.6761V28.5356Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 28.5356H57.6768V31.082H60.2992V28.5356Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 28.5356H65.542V31.082H68.1645V28.5356Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 28.5356H70.7842V31.082H73.4066V28.5356Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 28.5356H76.0273V31.082H78.6498V28.5356Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 28.5356H78.6504V31.082H81.2729V28.5356Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 28.5356H81.2715V31.082H83.894V28.5356Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 28.5356H83.8916V31.082H86.514V28.5356Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 31.0825H5.24316V33.6289H7.86563V31.0825Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 31.0825H20.9727V33.6289H23.5951V31.0825Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 31.0825H26.2178V33.6289H28.8402V31.0825Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 31.0825H28.8379V33.6289H31.4604V31.0825Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 31.0825H31.4609V33.6289H34.0834V31.0825Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 31.0825H41.9473V33.6289H44.5697V31.0825Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 31.0825H47.1895V33.6289H49.8119V31.0825Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M52.435 31.0825H49.8125V33.6289H52.435V31.0825Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 31.0825H60.2969V33.6289H62.9193V31.0825Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 31.0825H65.542V33.6289H68.1645V31.0825Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 31.0825H70.7842V33.6289H73.4066V31.0825Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 31.0825H73.4072V33.6289H76.0297V31.0825Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 31.0825H76.0273V33.6289H78.6498V31.0825Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 31.0825H83.8916V33.6289H86.514V31.0825Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 31.0825H86.5137V33.6289H89.1361V31.0825Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 31.0825H89.1367V33.6289H91.7592V31.0825Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 33.6294H10.4883V36.1758H13.1107V33.6294Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 33.6294H13.1074V36.1758H15.7299V33.6294Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 33.6294H23.5947V36.1758H26.2172V33.6294Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 33.6294H26.2178V36.1758H28.8402V33.6294Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 33.6294H31.4609V36.1758H34.0834V33.6294Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 33.6294H44.5674V36.1758H47.1899V33.6294Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 33.6294H49.8115V36.1758H52.434V33.6294Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 33.6294H57.6768V36.1758H60.2992V33.6294Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 33.6294H68.1621V36.1758H70.7846V33.6294Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 33.6294H70.7842V36.1758H73.4066V33.6294Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 33.6294H76.0273V36.1758H78.6498V33.6294Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 33.6294H78.6484V36.1758H81.2709V33.6294Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 33.6294H81.2715V36.1758H83.894V33.6294Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 33.6294H83.8916V36.1758H86.514V33.6294Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 33.6294H86.5137V36.1758H89.1361V33.6294Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 36.1729H5.24316V38.7192H7.86563V36.1729Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4887 36.1729H7.86621V38.7192H10.4887V36.1729Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 36.1729H10.4883V38.7192H13.1107V36.1729Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 36.1729H13.1074V38.7192H15.7299V36.1729Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 36.1729H18.3525V38.7192H20.975V36.1729Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 36.1729H20.9727V38.7192H23.5951V36.1729Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 36.1729H23.5947V38.7192H26.2172V36.1729Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 36.1729H62.9189V38.7192H65.5414V36.1729Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 36.1729H65.542V38.7192H68.1645V36.1729Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 36.1729H73.4072V38.7192H76.0297V36.1729Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 36.1729H76.0273V38.7192H78.6498V36.1729Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 36.1729H81.2715V38.7192H83.894V36.1729Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 36.1729H89.1367V38.7192H91.7592V36.1729Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 38.7197H5.24316V41.2661H7.86563V38.7197Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 38.7197H13.1074V41.2661H15.7299V38.7197Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 38.7197H26.2178V41.2661H28.8402V38.7197Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 38.7197H62.9189V41.2661H65.5414V38.7197Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 38.7197H65.542V41.2661H68.1645V38.7197Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 38.7197H76.0273V41.2661H78.6498V38.7197Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 38.7197H86.5137V41.2661H89.1361V38.7197Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 41.2656H5.24316V43.812H7.86563V41.2656Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 41.2656H13.1074V43.812H15.7299V41.2656Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 41.2656H18.3525V43.812H20.975V41.2656Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 41.2656H20.9727V43.812H23.5951V41.2656Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 41.2656H23.5947V43.812H26.2172V41.2656Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 41.2656H26.2178V43.812H28.8402V41.2656Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 41.2656H31.4609V43.812H34.0834V41.2656Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 41.2656H68.1621V43.812H70.7846V41.2656Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 43.8096H5.24316V46.3559H7.86563V43.8096Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4877 43.8096H7.86523V46.3559H10.4877V43.8096Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 43.8096H10.4883V46.3559H13.1107V43.8096Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 43.8096H13.1074V46.3559H15.7299V43.8096Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18.352 43.8096H15.7295V46.3559H18.352V43.8096Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 43.8096H23.5947V46.3559H26.2172V43.8096Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 43.8096H68.1621V46.3559H70.7846V43.8096Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 43.8096H70.7842V46.3559H73.4066V43.8096Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 43.8096H73.4072V46.3559H76.0297V43.8096Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 43.8096H78.6484V46.3559H81.2709V43.8096Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 43.8096H83.8916V46.3559H86.514V43.8096Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 43.8096H86.5137V46.3559H89.1361V43.8096Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 46.3555H5.24316V48.9018H7.86563V46.3555Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4877 46.3555H7.86523V48.9018H10.4877V46.3555Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 46.3555H18.3525V48.9018H20.975V46.3555Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 46.3555H20.9727V48.9018H23.5951V46.3555Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 46.3555H26.2178V48.9018H28.8402V46.3555Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 46.355H65.542V48.9014H68.1645V46.355Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 46.3555H70.7842V48.9018H73.4066V46.3555Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 46.3555H73.4072V48.9018H76.0297V46.3555Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 46.3555H76.0273V48.9018H78.6498V46.3555Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 46.3555H78.6484V48.9018H81.2709V46.3555Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 46.3555H81.2715V48.9018H83.894V46.3555Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 46.3555H86.5137V48.9018H89.1361V46.3555Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4887 48.9023H7.86621V51.4487H10.4887V48.9023Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 48.9023H13.1074V51.4487H15.7299V48.9023Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 48.9023H18.3525V51.4487H20.975V48.9023Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 48.9023H26.2178V51.4487H28.8402V48.9023Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 48.9023H28.8379V51.4487H31.4604V48.9023Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 48.9023H31.4609V51.4487H34.0834V48.9023Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 48.9023H62.9189V51.4487H65.5414V48.9023Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 48.9023H68.1621V51.4487H70.7846V48.9023Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 48.9023H73.4072V51.4487H76.0297V48.9023Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 48.9023H76.0273V51.4487H78.6498V48.9023Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 48.9023H78.6504V51.4487H81.2729V48.9023Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 48.9023H81.2715V51.4487H83.894V48.9023Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 48.9023H86.5137V51.4487H89.1361V48.9023Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 48.9023H89.1367V51.4487H91.7592V48.9023Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 51.4463H5.24316V53.9927H7.86563V51.4463Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4877 51.4463H7.86523V53.9927H10.4877V51.4463Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 51.4463H10.4883V53.9927H13.1107V51.4463Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 51.4458H18.3525V53.9922H20.975V51.4458Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 51.4463H20.9727V53.9927H23.5951V51.4463Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 51.4463H23.5947V53.9927H26.2172V51.4463Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 51.4463H31.4609V53.9927H34.0834V51.4463Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 51.4463H62.9189V53.9927H65.5414V51.4463Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 51.4463H65.542V53.9927H68.1645V51.4463Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 51.4458H76.0273V53.9922H78.6498V51.4458Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 51.4463H81.2715V53.9927H83.894V51.4463Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 51.4463H83.8916V53.9927H86.514V51.4463Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 51.4463H89.1367V53.9927H91.7592V51.4463Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4877 53.9927H7.86523V56.539H10.4877V53.9927Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 53.9927H10.4883V56.539H13.1107V53.9927Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 53.9927H18.3525V56.539H20.975V53.9927Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 53.9927H28.8379V56.539H31.4604V53.9927Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 53.9927H31.4609V56.539H34.0834V53.9927Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 53.9927H62.9189V56.539H65.5414V53.9927Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 53.9927H65.542V56.539H68.1645V53.9927Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 53.9927H68.1621V56.539H70.7846V53.9927Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 53.9927H76.0273V56.539H78.6498V53.9927Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 53.9927H78.6484V56.539H81.2709V53.9927Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 53.9927H81.2715V56.539H83.894V53.9927Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 53.9927H83.8916V56.539H86.514V53.9927Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 53.9927H86.5137V56.539H89.1361V53.9927Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 53.9927H89.1367V56.539H91.7592V53.9927Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 56.5386H5.24316V59.0849H7.86563V56.5386Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4877 56.5386H7.86523V59.0849H10.4877V56.5386Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 56.5386H13.1074V59.0849H15.7299V56.5386Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 56.5386H20.9727V59.0849H23.5951V56.5386Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 56.5386H23.5947V59.0849H26.2172V56.5386Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 56.5386H68.1621V59.0849H70.7846V56.5386Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 56.5386H76.0273V59.0849H78.6498V56.5386Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 56.5386H81.2715V59.0849H83.894V56.5386Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 59.082H5.24316V61.6283H7.86563V59.082Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4887 59.082H7.86621V61.6283H10.4887V59.082Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 59.082H13.1074V61.6283H15.7299V59.082Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M18.352 59.082H15.7295V61.6283H18.352V59.082Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 59.082H28.8379V61.6283H31.4604V59.082Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 59.082H36.7031V61.6283H39.3256V59.082Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 59.082H39.3242V61.6283H41.9467V59.082Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 59.082H41.9473V61.6283H44.5697V59.082Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M52.435 59.082H49.8125V61.6283H52.435V59.082Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 59.082H52.4316V61.6283H55.0541V59.082Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 59.082H55.0537V61.6283H57.6761V59.082Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 59.082H57.6768V61.6283H60.2992V59.082Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 59.082H68.1621V61.6283H70.7846V59.082Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 59.082H76.0273V61.6283H78.6498V59.082Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 59.082H78.6504V61.6283H81.2729V59.082Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 59.082H81.2715V61.6283H83.894V59.082Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 61.6289H5.24316V64.1753H7.86563V61.6289Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 61.6289H10.4883V64.1753H13.1107V61.6289Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 61.6289H20.9727V64.1753H23.5951V61.6289Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 61.6294H31.4609V64.1758H34.0834V61.6294Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 61.6294H34.083V64.1758H36.7055V61.6294Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 61.6294H36.7031V64.1758H39.3256V61.6294Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 61.6294H39.3242V64.1758H41.9467V61.6294Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 61.6294H41.9473V64.1758H44.5697V61.6294Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 61.6294H47.1895V64.1758H49.8119V61.6294Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 61.6294H49.8115V64.1758H52.434V61.6294Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 61.6289H65.542V64.1753H68.1645V61.6289Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 61.6294H73.4072V64.1758H76.0297V61.6294Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 61.6294H76.0273V64.1758H78.6498V61.6294Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 61.6289H81.2715V64.1753H83.894V61.6289Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 61.6289H86.5137V64.1753H89.1361V61.6289Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 61.6294H89.1367V64.1758H91.7592V61.6294Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 64.1753H5.24316V66.7217H7.86563V64.1753Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7299 64.1753H13.1074V66.7217H15.7299V64.1753Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 64.1753H26.2178V66.7217H28.8402V64.1753Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 64.1753H36.7031V66.7217H39.3256V64.1753Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 64.1753H44.5674V66.7217H47.1899V64.1753Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 64.1753H47.1895V66.7217H49.8119V64.1753Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 64.1753H55.0537V66.7217H57.6761V64.1753Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 64.1753H62.9189V66.7217H65.5414V64.1753Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 64.1753H65.542V66.7217H68.1645V64.1753Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 64.1753H76.0273V66.7217H78.6498V64.1753Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 64.1753H78.6484V66.7217H81.2709V64.1753Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 64.1753H83.8916V66.7217H86.514V64.1753Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 64.1753H86.5137V66.7217H89.1361V64.1753Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 64.1753H89.1367V66.7217H91.7592V64.1753Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86563 66.7197H5.24316V69.2661H7.86563V66.7197Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4887 66.7197H7.86621V69.2661H10.4887V66.7197Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1107 66.7197H10.4883V69.2661H13.1107V66.7197Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M18.352 66.7197H15.7295V69.2661H18.352V66.7197Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 66.7197H18.3525V69.2661H20.975V66.7197Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5951 66.7197H20.9727V69.2661H23.5951V66.7197Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2172 66.7197H23.5947V69.2661H26.2172V66.7197Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 66.7197H26.2178V69.2661H28.8402V66.7197Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 66.7197H34.082V69.2661H36.7045V66.7197Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 66.7197H36.7031V69.2661H39.3256V66.7197Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 66.7197H39.3242V69.2661H41.9467V66.7197Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 66.7197H41.9473V69.2661H44.5697V66.7197Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 66.7197H44.5674V69.2661H47.1899V66.7197Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 66.7197H52.4316V69.2661H55.0541V66.7197Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 66.7197H55.0537V69.2661H57.6761V66.7197Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 66.7197H68.1621V69.2661H70.7846V66.7197Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 66.7197H70.7842V69.2661H73.4066V66.7197Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 66.7197H73.4072V69.2661H76.0297V66.7197Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 66.7197H76.0273V69.2661H78.6498V66.7197Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 66.7197H78.6504V69.2661H81.2729V66.7197Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 66.7197H86.5137V69.2661H89.1361V66.7197Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 66.7197H89.1367V69.2661H91.7592V66.7197Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 69.2651H26.2178V71.8115H28.8402V69.2651Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 69.2651H28.8379V71.8115H31.4604V69.2651Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 69.2651H31.4609V71.8115H34.0834V69.2651Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 69.2651H34.082V71.8115H36.7045V69.2651Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 69.2651H39.3242V71.8115H41.9467V69.2651Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 69.2651H41.9473V71.8115H44.5697V69.2651Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 69.2651H47.1895V71.8115H49.8119V69.2651Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 69.2651H52.4316V71.8115H55.0541V69.2651Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 69.2651H55.0537V71.8115H57.6761V69.2651Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 69.2651H57.6768V71.8115H60.2992V69.2651Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 69.2651H60.2969V71.8115H62.9193V69.2651Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 69.2651H68.1621V71.8115H70.7846V69.2651Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 69.2651H78.6504V71.8115H81.2729V69.2651Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 69.2651H81.2715V71.8115H83.894V69.2651Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 69.2651H86.5137V71.8115H89.1361V69.2651Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 71.8115H26.2178V74.3579H28.8402V71.8115Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 71.8115H36.7031V74.3579H39.3256V71.8115Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 71.8115H39.3242V74.3579H41.9467V71.8115Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 71.8115H41.9473V74.3579H44.5697V71.8115Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 71.8115H44.5674V74.3579H47.1899V71.8115Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 71.8115H47.1895V74.3579H49.8119V71.8115Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 71.8115H52.4316V74.3579H55.0541V71.8115Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 71.812H57.6768V74.3584H60.2992V71.812Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 71.8115H65.542V74.3579H68.1645V71.8115Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 71.812H68.1621V74.3584H70.7846V71.812Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 71.812H73.4072V74.3584H76.0297V71.812Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 71.8115H78.6504V74.3579H81.2729V71.8115Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 74.356H28.8379V76.9023H31.4604V74.356Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 74.356H31.4609V76.9023H34.0834V74.356Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 74.356H39.3242V76.9023H41.9467V74.356Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 74.356H41.9473V76.9023H44.5697V74.356Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 74.356H44.5674V76.9023H47.1899V74.356Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 74.356H52.4316V76.9023H55.0541V74.356Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 74.356H60.2969V76.9023H62.9193V74.356Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 74.356H62.9189V76.9023H65.5414V74.356Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 74.356H65.542V76.9023H68.1645V74.356Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 74.356H68.1621V76.9023H70.7846V74.356Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 74.356H78.6484V76.9023H81.2709V74.356Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 74.356H81.2715V76.9023H83.894V74.356Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 74.356H83.8916V76.9023H86.514V74.356Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 74.356H86.5137V76.9023H89.1361V74.356Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 76.9028H26.2178V79.4492H28.8402V76.9028Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 76.9028H28.8379V79.4492H31.4604V76.9028Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 76.9028H31.4609V79.4492H34.0834V76.9028Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 76.9028H34.082V79.4492H36.7045V76.9028Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 76.9028H36.7031V79.4492H39.3256V76.9028Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 76.9028H39.3242V79.4492H41.9467V76.9028Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 76.9028H44.5674V79.4492H47.1899V76.9028Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M52.435 76.9028H49.8125V79.4492H52.435V76.9028Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 76.9028H52.4316V79.4492H55.0541V76.9028Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 76.9028H55.0537V79.4492H57.6761V76.9028Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 76.9028H60.2969V79.4492H62.9193V76.9028Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 76.9028H62.9189V79.4492H65.5414V76.9028Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 76.9028H65.542V79.4492H68.1645V76.9028Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 76.9028H68.1621V79.4492H70.7846V76.9028Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 76.9028H70.7842V79.4492H73.4066V76.9028Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 76.9028H73.4072V79.4492H76.0297V76.9028Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 76.9028H76.0273V79.4492H78.6498V76.9028Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2729 76.9028H78.6504V79.4492H81.2729V76.9028Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 76.9028H81.2715V79.4492H83.894V76.9028Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 76.9028H86.5137V79.4492H89.1361V76.9028Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 79.4487H26.2178V81.9951H28.8402V79.4487Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4604 79.4487H28.8379V81.9951H31.4604V79.4487Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0834 79.4487H31.4609V81.9951H34.0834V79.4487Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7045 79.4487H34.082V81.9951H36.7045V79.4487Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 79.4487H36.7031V81.9951H39.3256V79.4487Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 79.4487H39.3242V81.9951H41.9467V79.4487Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 79.4487H41.9473V81.9951H44.5697V79.4487Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 79.4487H44.5674V81.9951H47.1899V79.4487Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 79.4487H47.1895V81.9951H49.8119V79.4487Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M52.435 79.4487H49.8125V81.9951H52.435V79.4487Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 79.4487H55.0537V81.9951H57.6761V79.4487Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 79.4487H60.2969V81.9951H62.9193V79.4487Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 79.4487H62.9189V81.9951H65.5414V79.4487Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 79.4487H70.7842V81.9951H73.4066V79.4487Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6498 79.4487H76.0273V81.9951H78.6498V79.4487Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 79.4487H86.5137V81.9951H89.1361V79.4487Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 81.9922H36.7031V84.5385H39.3256V81.9922Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 81.9922H39.3242V84.5385H41.9467V81.9922Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 81.9922H44.5674V84.5385H47.1899V81.9922Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 81.9922H52.4316V84.5385H55.0541V81.9922Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 81.9927H57.6768V84.539H60.2992V81.9927Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 81.9927H60.2969V84.539H62.9193V81.9927Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 81.9927H62.9189V84.539H65.5414V81.9927Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 81.9922H78.6484V84.5385H81.2709V81.9922Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 81.9922H81.2715V84.5385H83.894V81.9922Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 81.9922H86.5137V84.5385H89.1361V81.9922Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 81.9922H89.1367V84.5385H91.7592V81.9922Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 84.5391H34.083V87.0854H36.7055V84.5391Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 84.5391H36.7031V87.0854H39.3256V84.5391Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 84.5391H47.1895V87.0854H49.8119V84.5391Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 84.5391H49.8115V87.0854H52.434V84.5391Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0541 84.5386H52.4316V87.0849H55.0541V84.5386Z",
    fill: "black"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9193 84.5386H60.2969V87.0849H62.9193V84.5386Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 84.5391H62.9189V87.0854H65.5414V84.5391Z",
    fill: "black"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 84.5391H65.542V87.0854H68.1645V84.5391Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 84.5391H70.7842V87.0854H73.4066V84.5391Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 84.5386H73.4072V87.0849H76.0297V84.5386Z",
    fill: "black"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M83.894 84.5391H81.2715V87.0854H83.894V84.5391Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M86.514 84.5391H83.8916V87.0854H86.514V84.5391Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1361 84.5391H86.5137V87.0854H89.1361V84.5391Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7592 84.5391H89.1367V87.0854H91.7592V84.5391Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7055 87.0854H34.083V89.6318H36.7055V87.0854Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3256 87.0854H36.7031V89.6318H39.3256V87.0854Z",
    fill: "black"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9467 87.0854H39.3242V89.6318H41.9467V87.0854Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5697 87.0854H41.9473V89.6318H44.5697V87.0854Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1899 87.0859H44.5674V89.6323H47.1899V87.0859Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8119 87.0859H47.1895V89.6323H49.8119V87.0859Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 87.0854H49.8115V89.6318H52.434V87.0854Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6761 87.0854H55.0537V89.6318H57.6761V87.0854Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2992 87.0854H57.6768V89.6318H60.2992V87.0854Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5414 87.0854H62.9189V89.6318H65.5414V87.0854Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1645 87.0854H65.542V89.6318H68.1645V87.0854Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7846 87.0854H68.1621V89.6318H70.7846V87.0854Z",
    fill: "black"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4066 87.0854H70.7842V89.6318H73.4066V87.0854Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0297 87.0854H73.4072V89.6318H76.0297V87.0854Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2709 87.0854H78.6484V89.6318H81.2709V87.0854Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8413 5.61865H8.00197H5.25195V8.28887V20.7557V23.4259H8.00197H20.8413H23.5913V20.7557V8.28887V5.61865H20.8413ZM20.8413 20.773H8.00197V8.30621H20.8413V20.773Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0015 5.61865H76.1621H73.4121V8.28887V20.7557V23.4259H76.1621H89.0015H91.7515V20.7557V8.28887V5.61865H89.0015ZM89.0015 20.773H76.1621V8.30621H89.0015V20.773Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8433 71.8169H8.00392H5.25391V74.4871V86.9539V89.6241H8.00392H20.8433H23.5933V86.9539V74.4871V71.8169H20.8433ZM20.8433 86.9539H8.00392V74.4871H20.8433V86.9539Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3557 10.7192H10.4883V18.3583H18.3557V10.7192Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5197 10.7192H78.6523V18.3583H86.5197V10.7192Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3557 76.9053H10.4883V84.5443H18.3557V76.9053Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_17800)"
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8613 52.9464C43.8613 53.0698 43.8418 53.1779 43.8066 53.2634C43.7707 53.3489 43.7241 53.4216 43.6669 53.4759C43.609 53.5327 43.5435 53.5712 43.4724 53.5963C43.3981 53.6213 43.327 53.6341 43.2559 53.6341H42.7983C42.6561 53.6341 42.5296 53.6182 42.4201 53.5834C42.3131 53.5486 42.2118 53.4882 42.113 53.3996C42.0173 53.311 41.9185 53.1907 41.8222 53.0381C41.7265 52.886 41.6221 52.6863 41.5126 52.4457L38.3381 45.6105C38.1707 45.2587 38.0039 44.888 37.8365 44.5014C37.6665 44.1148 37.5105 43.7374 37.3651 43.3734H37.3487C37.3594 43.8168 37.3682 44.2736 37.3733 44.739C37.3789 45.2019 37.3814 45.6642 37.3814 46.1204V53.3739C37.3814 53.4185 37.3707 53.4594 37.3487 53.501C37.3242 53.5388 37.2858 53.5706 37.2335 53.5926C37.1788 53.6146 37.1102 53.6335 37.0227 53.6494C36.9352 53.6653 36.8226 53.6714 36.6885 53.6714C36.5513 53.6714 36.4393 53.6653 36.3512 53.6494C36.2637 53.6335 36.1951 53.6146 36.1454 53.5926C36.0931 53.5706 36.0579 53.5388 36.0327 53.501C36.0107 53.4601 36 53.4185 36 53.3746V42.2863C36 42.039 36.0604 41.8619 36.1838 41.7568C36.304 41.6524 36.4361 41.5986 36.5809 41.5986H37.2606C37.4198 41.5986 37.5539 41.6145 37.6609 41.6463C37.7704 41.675 37.8667 41.7287 37.9516 41.7984C38.0366 41.868 38.1216 41.9694 38.2009 42.0964C38.2802 42.2234 38.3651 42.3816 38.4532 42.5752L40.8926 47.8481C41.0437 48.1712 41.1884 48.4851 41.3282 48.7923C41.4679 49.0995 41.6051 49.4006 41.7341 49.6986C41.8631 49.9936 41.9915 50.288 42.118 50.5762C42.247 50.8614 42.3704 51.1528 42.4962 51.4447H42.5044C42.4937 50.9537 42.4849 50.4462 42.4824 49.9173C42.4799 49.3878 42.4799 48.8778 42.4799 48.3899V41.8771C42.4799 41.8326 42.4906 41.7916 42.5126 41.7568C42.5372 41.719 42.5755 41.6872 42.6278 41.6585C42.6825 41.6298 42.7537 41.6109 42.8386 41.598C42.9261 41.5852 43.0413 41.5791 43.1841 41.5791C43.3075 41.5791 43.4145 41.5852 43.5051 41.598C43.5957 41.6109 43.6669 41.6298 43.7159 41.6585C43.7682 41.6872 43.8034 41.719 43.8286 41.7568C43.8506 41.7916 43.8613 41.8332 43.8613 41.8771V52.9464Z",
    fill: "url(#paint0_linear_899_17800)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 41,
    width: 8,
    height: 13
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8613 52.9464C43.8613 53.0698 43.8418 53.1779 43.8066 53.2634C43.7707 53.3489 43.7241 53.4216 43.6669 53.4759C43.609 53.5327 43.5435 53.5712 43.4724 53.5963C43.3981 53.6213 43.327 53.6341 43.2559 53.6341H42.7983C42.6561 53.6341 42.5296 53.6182 42.4201 53.5834C42.3131 53.5486 42.2118 53.4882 42.113 53.3996C42.0173 53.311 41.9185 53.1907 41.8222 53.0381C41.7265 52.886 41.6221 52.6863 41.5126 52.4457L38.3381 45.6105C38.1707 45.2587 38.0039 44.888 37.8365 44.5014C37.6665 44.1148 37.5105 43.7374 37.3651 43.3734H37.3487C37.3594 43.8168 37.3682 44.2736 37.3733 44.739C37.3789 45.2019 37.3814 45.6642 37.3814 46.1204V53.3739C37.3814 53.4185 37.3707 53.4594 37.3487 53.501C37.3242 53.5388 37.2858 53.5706 37.2335 53.5926C37.1788 53.6146 37.1102 53.6335 37.0227 53.6494C36.9352 53.6653 36.8226 53.6714 36.6885 53.6714C36.5513 53.6714 36.4393 53.6653 36.3512 53.6494C36.2637 53.6335 36.1951 53.6146 36.1454 53.5926C36.0931 53.5706 36.0579 53.5388 36.0327 53.501C36.0107 53.4601 36 53.4185 36 53.3746V42.2863C36 42.039 36.0604 41.8619 36.1838 41.7568C36.304 41.6524 36.4361 41.5986 36.5809 41.5986H37.2606C37.4198 41.5986 37.5539 41.6145 37.6609 41.6463C37.7704 41.675 37.8667 41.7287 37.9516 41.7984C38.0366 41.868 38.1216 41.9694 38.2009 42.0964C38.2802 42.2234 38.3651 42.3816 38.4532 42.5752L40.8926 47.8481C41.0437 48.1712 41.1884 48.4851 41.3282 48.7923C41.4679 49.0995 41.6051 49.4006 41.7341 49.6986C41.8631 49.9936 41.9915 50.288 42.118 50.5762C42.247 50.8614 42.3704 51.1528 42.4962 51.4447H42.5044C42.4937 50.9537 42.4849 50.4462 42.4824 49.9173C42.4799 49.3878 42.4799 48.8778 42.4799 48.3899V41.8771C42.4799 41.8326 42.4906 41.7916 42.5126 41.7568C42.5372 41.719 42.5755 41.6872 42.6278 41.6585C42.6825 41.6298 42.7537 41.6109 42.8386 41.598C42.9261 41.5852 43.0413 41.5791 43.1841 41.5791C43.3075 41.5791 43.4145 41.5852 43.5051 41.598C43.5957 41.6109 43.6669 41.6298 43.7159 41.6585C43.7682 41.6872 43.8034 41.719 43.8286 41.7568C43.8506 41.7916 43.8613 41.8332 43.8613 41.8771V52.9464Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8613 41.5791H36V53.672H43.8613V41.5791Z",
    fill: "url(#paint1_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 41,
    width: 9,
    height: 13
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5598 47.4532C60.5598 46.7936 60.5133 46.1774 60.4201 45.61C60.327 45.0433 60.1728 44.5498 59.955 44.1309C59.7373 43.715 59.4484 43.3882 59.0859 43.1537C58.7209 42.9198 58.2728 42.8026 57.7391 42.8026C57.2028 42.8026 56.7547 42.929 56.3922 43.1818C56.0297 43.4347 55.7333 43.7706 55.5086 44.1895C55.2808 44.6115 55.119 45.1019 55.0215 45.6656C54.9233 46.2263 54.8748 46.815 54.8748 47.4343C54.8748 48.1213 54.9214 48.7504 55.012 49.3263C55.1027 49.9059 55.2543 50.4018 55.4696 50.8207C55.6823 51.2366 55.9718 51.5603 56.3312 51.7912C56.6912 52.022 57.1443 52.1393 57.6875 52.1393C58.2287 52.1393 58.6818 52.0128 59.0488 51.76C59.4163 51.5072 59.7121 51.1682 59.9374 50.737C60.1602 50.3089 60.322 49.8094 60.417 49.2457C60.5133 48.6832 60.5598 48.0853 60.5598 47.4532ZM61.867 47.3457C61.867 48.2917 61.7789 49.1425 61.6027 49.9004C61.424 50.6583 61.1596 51.3026 60.8091 51.8357C60.4566 52.3658 60.0161 52.7756 59.4843 53.0621C58.9531 53.3485 58.3338 53.4902 57.6258 53.4902C56.9278 53.4902 56.3255 53.3607 55.8164 53.0987C55.3047 52.8367 54.8862 52.4544 54.5532 51.9554C54.2203 51.4565 53.973 50.8366 53.8112 50.097C53.647 49.3574 53.5664 48.5067 53.5664 47.5454C53.5664 46.6238 53.6545 45.7859 53.8307 45.0335C54.0095 44.2817 54.2738 43.6435 54.6288 43.1165C54.9812 42.5925 55.4243 42.1857 55.9561 41.8993C56.4847 41.6129 57.1047 41.4712 57.8146 41.4712C58.4974 41.4712 59.0928 41.6007 59.5994 41.8596C60.1061 42.1186 60.5296 42.4941 60.8651 42.9907C61.2031 43.4866 61.4554 44.1003 61.6191 44.8338C61.784 45.5642 61.867 46.4028 61.867 47.3457Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.868 41.4717H53.5674V53.4907H61.868V41.4717Z",
    fill: "url(#paint2_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 49,
    width: 9,
    height: 5
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8378 51.5558L52.4417 49.5679C52.5915 49.5288 52.7463 49.6241 52.752 49.7743L52.7992 51.0281C52.8049 51.1783 52.6003 51.1844 52.4512 51.2248L44.8907 53.2646C44.7415 53.3049 44.6735 53.1815 44.6698 53.0313L44.6389 51.8904C44.6345 51.7402 44.688 51.5949 44.8378 51.5558Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8041 49.5264H44.6338V53.3025H52.8041V49.5264Z",
    fill: "url(#paint3_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 45,
    width: 9,
    height: 5
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8378 47.4493L52.4417 45.4614C52.5915 45.4223 52.7463 45.5176 52.752 45.6678L52.7992 46.9217C52.8049 47.0719 52.6003 47.078 52.4512 47.1183L44.8907 49.1581C44.7415 49.1984 44.6735 49.0751 44.6698 48.9248L44.6389 47.784C44.6345 47.6338 44.688 47.4884 44.8378 47.4493Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8041 45.4209H44.6338V49.197H52.8041V45.4209Z",
    fill: "url(#paint4_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 41,
    width: 9,
    height: 5
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8378 43.3453L52.4417 41.3574C52.5915 41.3183 52.7463 41.4136 52.752 41.5638L52.7992 42.8177C52.8049 42.9679 52.6003 42.974 52.4512 43.0137L44.8907 45.0535C44.7415 45.0938 44.6735 44.9704 44.6698 44.8202L44.6389 43.6794C44.6345 43.5298 44.688 43.3844 44.8378 43.3453Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8041 41.3169H44.6338V45.093H52.8041V41.3169Z",
    fill: "url(#paint5_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 46,
    width: 1,
    height: 4
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4014 48.9183V46.8156C56.4014 46.7063 56.4247 46.6251 56.4719 46.5701C56.5184 46.5152 56.5795 46.4883 56.6544 46.4883C56.7305 46.4883 56.7928 46.5152 56.84 46.5689C56.8872 46.6233 56.9118 46.7051 56.9118 46.8156V48.9183C56.9118 49.0289 56.8879 49.1113 56.84 49.1657C56.7928 49.2206 56.7305 49.2475 56.6544 49.2475C56.5814 49.2475 56.5209 49.22 56.4731 49.1651C56.4253 49.1101 56.4014 49.0277 56.4014 48.9183Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9111 46.4883H56.4014V49.2481H56.9111V46.4883Z",
    fill: "url(#paint6_linear_899_17800)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_899_17800",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 46,
    width: 3,
    height: 4
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1322 46.8727V46.9545C58.226 46.7975 58.3292 46.6833 58.4399 46.6101C58.5513 46.5368 58.6791 46.5007 58.8238 46.5007C58.9648 46.5007 59.0901 46.5392 59.2015 46.6168C59.3122 46.6937 59.3947 46.803 59.4494 46.9447C59.4847 47.0272 59.5073 47.1157 59.518 47.2122C59.5281 47.3075 59.5331 47.429 59.5331 47.5774V48.8325C59.5331 48.9674 59.5086 49.0694 59.4595 49.1384C59.411 49.2074 59.3468 49.2423 59.2688 49.2423C59.1895 49.2423 59.1247 49.2068 59.075 49.136C59.0259 49.0651 59.0007 48.9638 59.0007 48.8325V47.7081C59.0007 47.4864 58.9761 47.316 58.9271 47.1982C58.8786 47.0809 58.781 47.0223 58.635 47.0223C58.5406 47.0223 58.4538 47.0577 58.3751 47.1292C58.2971 47.2006 58.2398 47.2996 58.2039 47.4248C58.1781 47.5249 58.1643 47.7124 58.1643 47.9878V48.8325C58.1643 48.9693 58.1391 49.0713 58.0888 49.139C58.039 49.2074 57.9742 49.2416 57.8955 49.2416C57.8188 49.2416 57.7558 49.2062 57.7061 49.1354C57.657 49.0645 57.6318 48.9632 57.6318 48.8319V46.8824C57.6318 46.7542 57.6539 46.6583 57.6979 46.5948C57.7426 46.5313 57.8024 46.4995 57.8792 46.4995C57.9257 46.4995 57.9685 46.5136 58.0057 46.5417C58.0434 46.5697 58.0736 46.6119 58.0963 46.6675C58.1208 46.7236 58.1322 46.7927 58.1322 46.8727Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_899_17800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5328 46.5H57.6328V49.2409H59.5328V46.5Z",
    fill: "url(#paint7_linear_899_17800)"
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6772 46.1236C56.6029 46.1236 56.5393 46.1004 56.4858 46.054C56.4317 46.0076 56.4053 45.9422 56.4053 45.8592C56.4053 45.7877 56.4311 45.7273 56.4827 45.6759C56.5343 45.6246 56.5979 45.5996 56.6734 45.5996C56.7489 45.5996 56.8131 45.6246 56.866 45.6753C56.9195 45.726 56.9453 45.7871 56.9453 45.8598C56.9453 45.9416 56.9188 46.0063 56.866 46.0534C56.8118 46.0998 56.7495 46.1236 56.6772 46.1236Z",
    fill: "#00E9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_17800",
    x1: 36,
    y1: 47.6257,
    x2: 43.8616,
    y2: 47.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_17800",
    x1: 40.0432,
    y1: 42.0597,
    x2: 39.8364,
    y2: 52.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_17800",
    x1: 58.0429,
    y1: 42.3108,
    x2: 57.3938,
    y2: 53.2555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_899_17800",
    x1: 44.8917,
    y1: 51.7221,
    x2: 52.5119,
    y2: 51.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_899_17800",
    x1: 44.8917,
    y1: 47.6166,
    x2: 52.5119,
    y2: 46.9663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_899_17800",
    x1: 44.8917,
    y1: 43.5128,
    x2: 52.5119,
    y2: 42.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_899_17800",
    x1: 56.6636,
    y1: 46.6482,
    x2: 56.6512,
    y2: 48.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_899_17800",
    x1: 58.5571,
    y1: 46.6875,
    x2: 58.6086,
    y2: 49.1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_17800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8667,
    height: 12.3555,
    fill: "white",
    transform: "translate(36 41.3169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrWithNeoin);
export default __webpack_public_path__ + "static/media/QR-with-Neoin.61e5ac2f482d8ac1635d8411eb408970.svg";
export { ForwardRef as ReactComponent };